import { WindowPostMessageProxy, IMessageHandler } from 'window-post-message-proxy';
import * as m from './messages';

interface ICallbackItem {
    [key: string]: Function;
}

export class MessengerService implements IMessageHandler {
    private readonly proxy: WindowPostMessageProxy;
    private callbackQueue: ICallbackItem = {};
    public readonly isEnabled: boolean;
    private clientId: string = '';
    private frameId: string = '';

    constructor(private readonly window: Window) {
        this.isEnabled = this.window !== this.window.parent && !this.window.opener;
        this.proxy = new WindowPostMessageProxy({ suppressWarnings: true });
        if (this.isEnabled) {
            this.proxy.addHandler(this);
            this.proxy.start();
        }
    }

    /**
     * Test if service is active
     * @param message
     * @returns Boolean
     */
    test(message: any): boolean {
        if (message && message.type) {
            switch (message.type) {
                case m.INIT:
                case m.CALLBACK:
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    /**
     * Create object and add item to project
     * @param payload Payload to add to project
     * @param callback Trigger when operation done
     */
    create(payload: m.ICreate[], callback?: (data: any) => void) {
        let data = new m.SetCreateMessage(payload);
        // add callback method if provided
        if (callback) {
            this.callbackQueue[data.requestId] = callback;
        }
        this.send(data);
    }

    read() {
        return 'To be implemented';
    }

    update() {
        return 'To be implemented';
    }

    delete() {
        return 'To be implemented';
    }

    /**
     * Trigger callback method when response received from parent
     * @param callback
     */
    private callback(data: m.CallbackMessage) {
        let requestId = data.requestId;
        if (this.callbackQueue[requestId]) {
            this.callbackQueue[requestId](data.data);
            delete this.callbackQueue[requestId];
        }
    }

    /**
     * Receive messages from parent
     * @param message
     */
    handle(message: Readonly<m.IMessage>) {
        switch (message.type) {
            case m.INIT:
                const data = message as m.InitMessage;
                this.clientId = data.clientId;
                this.frameId = data.frameId;
                break;
            case m.CALLBACK:
                this.callback(message as m.CallbackMessage);
                break;
        }
        return { success: true };
    }

    /**
     * Send message to parent
     * @param message
     */
    send(message: m.IMessage): void {
        this.proxy.postMessage(this.window.parent as unknown as Window, {
            clientId: this.clientId,
            frameId: this.frameId,
            ...message,
        });
    }
}
